export type AppRoute =
  | { type: "home" }
  | { type: "project"; projectId: string }
  | { type: "board"; boardId: string; projectId?: string | null };

export const parseAppRoute = (): AppRoute => {
  const params = new URLSearchParams(window.location.search);
  const boardId = params.get("board");
  const projectId = params.get("project");
  if (boardId) {
    return { type: "board", boardId, projectId };
  }
  if (projectId) {
    return { type: "project", projectId };
  }
  return { type: "home" };
};

export const navigateApp = (
  route: AppRoute,
  replace = false,
  opts?: { notify?: boolean },
) => {
  const url = new URL(window.location.href);
  url.searchParams.delete("board");
  url.searchParams.delete("project");
  url.searchParams.delete("view");

  if (route.type === "board") {
    url.searchParams.set("board", route.boardId);
    if (route.projectId) {
      url.searchParams.set("project", route.projectId);
    }
  } else if (route.type === "project") {
    url.searchParams.set("project", route.projectId);
  }

  const next = `${url.pathname}${url.search}${url.hash}`;
  if (replace) {
    window.history.replaceState({}, document.title, next);
  } else {
    window.history.pushState({}, document.title, next);
  }
  // Skip notify for in-page project switches so the workspace is not remounted.
  if (opts?.notify !== false) {
    window.dispatchEvent(new PopStateEvent("popstate"));
  }
};
